import Footer from './footer';
import Header from './header';

export default function NotFound() {
  return (
    <section className="flex flex-col min-h-dvh w-full">
      <Header />
      <section className="flex flex-grow w-full flex-col justify-center items-center py-4">
        <div className="flex flex-col items-center gap-4">
          <h1 className="text-2xl font-bold">Page non trouvée</h1>
          <p className="text-sm text-gray-500">
            La page que vous cherchez n'existe pas.
          </p>
        </div>
      </section>
      <Footer />
    </section>
  );
}
